import { HrmCertificateDto, defaultHrmCertificateDto } from 'src/dtos/hrmCertificate/hrmCertificateDto';

/** 증명서 엔티티 필드에 그리드 표시명을 더한 화면 행이다. */
export interface HRM1060_R01Dto extends HrmCertificateDto {
    empNm: string; // 사원명
    certTypeNm: string; // 증명서명
    issueStsNm: string; // 발급상태명
}

/** 신규 행을 만들 때 쓰는 화면 필드 기본값이다. */
export const defaultHRM1060_R01Dto: HRM1060_R01Dto = {
    ...defaultHrmCertificateDto, // 엔티티 필드의 기본값을 이어받는다
    empNm: '', certTypeNm: '', issueStsNm: '',
};
